/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrendsRouteImport } from './routes/trends'
import { Route as TrajectoryRouteImport } from './routes/trajectory'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as LogRouteImport } from './routes/log'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as DayRouteImport } from './routes/day'
import { Route as IndexRouteImport } from './routes/index'

const TrendsRoute = TrendsRouteImport.update({
  id: '/trends',
  path: '/trends',
  getParentRoute: () => rootRouteImport,
} as any)
const TrajectoryRoute = TrajectoryRouteImport.update({
  id: '/trajectory',
  path: '/trajectory',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanRoute = PlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuRoute = MenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => rootRouteImport,
} as any)
const LogRoute = LogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const DayRoute = DayRouteImport.update({
  id: '/day',
  path: '/day',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/day': typeof DayRoute
  '/feedback': typeof FeedbackRoute
  '/log': typeof LogRoute
  '/menu': typeof MenuRoute
  '/plan': typeof PlanRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRoute
  '/trajectory': typeof TrajectoryRoute
  '/trends': typeof TrendsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/day': typeof DayRoute
  '/feedback': typeof FeedbackRoute
  '/log': typeof LogRoute
  '/menu': typeof MenuRoute
  '/plan': typeof PlanRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRoute
  '/trajectory': typeof TrajectoryRoute
  '/trends': typeof TrendsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/day': typeof DayRoute
  '/feedback': typeof FeedbackRoute
  '/log': typeof LogRoute
  '/menu': typeof MenuRoute
  '/plan': typeof PlanRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRoute
  '/trajectory': typeof TrajectoryRoute
  '/trends': typeof TrendsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/day'
    | '/feedback'
    | '/log'
    | '/menu'
    | '/plan'
    | '/review'
    | '/settings'
    | '/trajectory'
    | '/trends'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/day'
    | '/feedback'
    | '/log'
    | '/menu'
    | '/plan'
    | '/review'
    | '/settings'
    | '/trajectory'
    | '/trends'
  id:
    | '__root__'
    | '/'
    | '/day'
    | '/feedback'
    | '/log'
    | '/menu'
    | '/plan'
    | '/review'
    | '/settings'
    | '/trajectory'
    | '/trends'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DayRoute: typeof DayRoute
  FeedbackRoute: typeof FeedbackRoute
  LogRoute: typeof LogRoute
  MenuRoute: typeof MenuRoute
  PlanRoute: typeof PlanRoute
  ReviewRoute: typeof ReviewRoute
  SettingsRoute: typeof SettingsRoute
  TrajectoryRoute: typeof TrajectoryRoute
  TrendsRoute: typeof TrendsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trends': {
      id: '/trends'
      path: '/trends'
      fullPath: '/trends'
      preLoaderRoute: typeof TrendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trajectory': {
      id: '/trajectory'
      path: '/trajectory'
      fullPath: '/trajectory'
      preLoaderRoute: typeof TrajectoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan': {
      id: '/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof PlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu': {
      id: '/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof MenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/log': {
      id: '/log'
      path: '/log'
      fullPath: '/log'
      preLoaderRoute: typeof LogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/day': {
      id: '/day'
      path: '/day'
      fullPath: '/day'
      preLoaderRoute: typeof DayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DayRoute: DayRoute,
  FeedbackRoute: FeedbackRoute,
  LogRoute: LogRoute,
  MenuRoute: MenuRoute,
  PlanRoute: PlanRoute,
  ReviewRoute: ReviewRoute,
  SettingsRoute: SettingsRoute,
  TrajectoryRoute: TrajectoryRoute,
  TrendsRoute: TrendsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
